<div class="tiptap-wrapper">
  <div class="toolbar" *ngIf="editor">
    <div class="btn-group">
      <select (change)="setHeading(+$any($event.target).value)" style="height: 26px; padding: 2px 6px; font-size: 13px;">
        <option value="0" [selected]="editor.isActive('paragraph')">Paragraph</option>
        <option value="1" [selected]="editor.isActive('heading', { level: 1 })">Heading 1</option>
        <option value="2" [selected]="editor.isActive('heading', { level: 2 })">Heading 2</option>
        <option value="3" [selected]="editor.isActive('heading', { level: 3 })">Heading 3</option>
        <option value="4" [selected]="editor.isActive('heading', { level: 4 })">Heading 4</option>
      </select>
    </div>
    <span class="separator"></span>
    <button type="button" (click)="toggleBold()" [class.active]="editor.isActive('bold')" title="Bold">
      <i class="fa fa-bold"></i>
    </button>
    <button type="button" (click)="toggleItalic()" [class.active]="editor.isActive('italic')" title="Italic">
      <i class="fa fa-italic"></i>
    </button>
    <button type="button" (click)="toggleUnderline()" [class.active]="editor.isActive('underline')" title="Underline">
      <i class="fa fa-underline"></i>
    </button>
    <button type="button" (click)="toggleBlockquote()" [class.active]="editor.isActive('blockquote')" title="Quote">
      <i class="fa fa-quote-left"></i>
    </button>
    <span class="separator"></span>
    <button type="button" (click)="toggleLink()" [class.active]="editor.isActive('link')" title="Insert Link">
      <i class="fa fa-link"></i>
    </button>
    <span class="separator"></span>
    <button type="button" (click)="toggleBulletList()" [class.active]="editor.isActive('bulletList')" title="Bullet List">
      <i class="fa fa-list-ul"></i>
    </button>
    <button type="button" (click)="toggleOrderedList()" [class.active]="editor.isActive('orderedList')" title="Numbered List">
      <i class="fa fa-list-ol"></i>
    </button>
    <span class="separator"></span>
    <button type="button" (click)="toggleSubscript()" [class.active]="editor.isActive('subscript')" title="Subscript">
      <i class="fa fa-subscript"></i>
    </button>
    <button type="button" (click)="toggleSuperscript()" [class.active]="editor.isActive('superscript')" title="Superscript">
      <i class="fa fa-superscript"></i>
    </button>
    <span class="separator"></span>
    <button type="button" (click)="setTextAlign('left')" [class.active]="editor.isActive({ textAlign: 'left' })" title="Align Left">
      <i class="fa fa-align-left"></i>
    </button>
    <button type="button" (click)="setTextAlign('center')" [class.active]="editor.isActive({ textAlign: 'center' })" title="Align Center">
      <i class="fa fa-align-center"></i>
    </button>
    <button type="button" (click)="setTextAlign('right')" [class.active]="editor.isActive({ textAlign: 'right' })" title="Align Right">
      <i class="fa fa-align-right"></i>
    </button>
    <span class="separator"></span>
    <button type="button" (click)="clearFormatting()" title="Clear Formatting">
      <i class="fa fa-eraser"></i>
    </button>
  </div>
  <div class="editor-content" #editorElement></div>

  <!-- Link Editor Modal (inline overlay) -->
  <div class="link-modal-overlay" *ngIf="showLinkModal" (click)="closeLinkModal()">
    <div class="link-modal" (click)="$event.stopPropagation()">
      <div class="link-modal-header">
        <strong>Edit Link</strong>
        <button type="button" class="close-btn" (click)="closeLinkModal()">&times;</button>
      </div>
      <div class="link-modal-body">
        <div class="form-field">
          <label>Text</label>
          <input type="text" [(ngModel)]="currentLinkText" (keydown.enter)="saveLink()" />
        </div>
        <div class="form-field">
          <label>Type</label>
          <select [(ngModel)]="linkType" (ngModelChange)="onLinkTypeChange()">
            <option value="url">Web URL</option>
            <option value="mailto">Email Address</option>
            <option value="tel">Phone Number</option>
          </select>
        </div>
        <div class="form-field">
          <label>{{ linkInputLabel }}</label>
          <input type="text" [(ngModel)]="currentLinkUrl" (keydown.enter)="saveLink()" [placeholder]="linkInputPlaceholder" [class.error]="linkUrlError" />
          <div class="error-text" *ngIf="linkUrlError">{{ linkUrlError }}</div>
        </div>
      </div>
      <div class="link-modal-footer">
        <button type="button" class="btn-remove" (click)="removeLink()">
          <i class="fa fa-unlink"></i> Remove Link
        </button>
        <button type="button" class="btn-save" (click)="saveLink()">Save</button>
      </div>
    </div>
  </div>
</div>
